import { BuildingBlock, BuildingBlockLayouts, BuildingBlockProperties } from '@pendo/services/BuildingBlocks';
import cloneDeep from 'lodash/cloneDeep';
const { widgetIds } = BuildingBlockLayouts;
const { getPropertyByName } = BuildingBlockProperties;

export function getCaretBlockColors (caretBlock) {
    const caretStyles = caretBlock.web.pseudoStyles;
    const caretBeforeStyle = caretStyles.find((element) => {
        return element.selector.toString().includes('::before');
    });
    const borderDirection = caretBeforeStyle.selector.toString().includes('left') ? 'right' : 'left';
    const beforeColor = caretBeforeStyle.styles[`border-${borderDirection}-color`];

    const caretAfterStyle = caretStyles.find((element) => {
        return element.selector.toString().includes('::after');
    });
    const afterColor = caretAfterStyle.styles[`border-${borderDirection}-color`];

    return { foregroundColor: beforeColor, backgroundColor: afterColor };
}

export function setCaretBlockColors (caretBlock, colors) {
    const caretStyles = caretBlock.web.pseudoStyles;
    const caretBeforeStyle = caretStyles.find((element) => {
        return element.selector.toString().includes('::before');
    });
    const borderDirection = caretBeforeStyle.selector.toString().includes('left') ? 'right' : 'left';
    caretBeforeStyle.styles[`border-${borderDirection}-color`] = colors.foregroundColor;

    const caretAfterStyle = caretStyles.find((element) => {
        return element.selector.toString().includes('::after');
    });
    caretAfterStyle.styles[`border-${borderDirection}-color`] = colors.backgroundColor;
}

function setBlockFrameProperties (homeViewBuildingBlocks, newModuleBuildingBlocks) {
    const isGuideListModule = newModuleBuildingBlocks.web && newModuleBuildingBlocks.web.layout === 'GuideListModule';
    const isIframeModule = newModuleBuildingBlocks.web && newModuleBuildingBlocks.web.layout === 'IframeModule';
    const listBlock = BuildingBlock.findBlockByWidgetId(homeViewBuildingBlocks, widgetIds.orderedListBlock);
    const newCodeBlock = BuildingBlock.findBlockByWidgetId(newModuleBuildingBlocks, widgetIds.codeBlock);
    let newListBlock = BuildingBlock.findBlockByWidgetId(newModuleBuildingBlocks, widgetIds.orderedListBlock);

    if (isGuideListModule) {
        newListBlock = BuildingBlock.findBlockByDomId(newModuleBuildingBlocks, 'pendo-module-body-container');
    } else if (isIframeModule) {
        newListBlock = BuildingBlock.findBlockByWidgetId(newModuleBuildingBlocks, widgetIds.iframeBlock);
    }

    if (newListBlock && listBlock) {
        getPropertyByName(newListBlock.properties, 'frameTop').value = getPropertyByName(
            listBlock.properties,
            'frameTop',
        ).value;

        getPropertyByName(newListBlock.properties, 'frameColor').value = getPropertyByName(
            listBlock.properties,
            'frameColor',
        ).value;
    }

    if (!isGuideListModule && newCodeBlock && listBlock) {
        getPropertyByName(newCodeBlock.properties, 'frameTop').value = getPropertyByName(
            listBlock.properties,
            'frameTop',
        ).value;

        getPropertyByName(newCodeBlock.properties, 'frameColor').value = getPropertyByName(
            listBlock.properties,
            'frameColor',
        ).value;
    }
}

export function setNewModuleStyles (homeViewBuildingBlocks, newModuleBuildingBlocks) {
    // find styles from homeView and apply to the newModule
    const caretBlock = BuildingBlock.findBlockByWidgetId(homeViewBuildingBlocks, widgetIds.caret);
    const newModuleCaretBlock = BuildingBlock.findBlockByWidgetId(newModuleBuildingBlocks, widgetIds.caret);

    if (newModuleCaretBlock && caretBlock) {
        setCaretBlockColors(newModuleCaretBlock, getCaretBlockColors(caretBlock));
    }

    setBlockFrameProperties(homeViewBuildingBlocks, newModuleBuildingBlocks);

    const titleTextBlockContainer = BuildingBlock.findBlockByDomId(
        homeViewBuildingBlocks,
        'pendo-resource-center-module-title-container',
    );

    const titleTextBlock = BuildingBlock.findBlockByWidgetId(titleTextBlockContainer, widgetIds.h2Block);

    const newTitleTextBlockContainer = BuildingBlock.findBlockByDomId(
        newModuleBuildingBlocks,
        'pendo-resource-center-module-title-container',
    );

    const newTitleTextBlock = BuildingBlock.findBlockByWidgetId(newTitleTextBlockContainer, widgetIds.h2Block);

    if (newTitleTextBlock && titleTextBlock) {
        const clonedTitleTextBlock = cloneDeep(titleTextBlock);
        clonedTitleTextBlock.properties.find(
            (property) => property.name === 'text',
        ).value = newTitleTextBlock.properties.find((property) => property.name === 'text').value;
        // keeps all the modules from ending up with the same id as the homeView's h2Block
        clonedTitleTextBlock.web.domId = newTitleTextBlock.web.domId;

        BuildingBlock.replaceBlock(
            newTitleTextBlockContainer,
            clonedTitleTextBlock,
            (block) => block.widget === BuildingBlockLayouts.widgetIds.h2Block,
        );
    }
}
